import { useYearlyCycle } from "./useYearlyCycle";
import { useMemo } from "react";
import { TaskSection, TasksLoadingSkeleton } from "./TaskSection";
import { useAnnualCycleTasks } from "@dashboard/hooks/useTaskQuery";
import { withOccurrence, type TaskWithOccurrence } from "@dashboard/utils/taskWithOccurrence";

export function YearlyTasks() {
    const { year } = useYearlyCycle();

    const { data: tasks, isPending } = useAnnualCycleTasks();

    const data = useMemo(() => {
        if (!tasks) return [];

        return tasks
            .map((task) => withOccurrence(task, task.occurrences?.[0]))
            .filter((task) => task.dueDate.getFullYear() === year);
    }, [tasks, year]);

    const dataPerMonth = useMemo(() => {
        const map = new Map<number, TaskWithOccurrence[]>();
        [...Array(12).keys()].forEach((month) => map.set(month, []));
        data?.forEach((task) => {
            const month = task.dueDate.getMonth();
            map.get(month)?.push(task);
        });
        return map;
    }, [data]);

    return (
        <div className="flex h-full w-full flex-col gap-4 overflow-y-auto">
            {isPending && <TasksLoadingSkeleton />}
            {!isPending &&
                Array.from(dataPerMonth.entries()).map(([month, tasks]) => {
                    return <TaskSection key={month} month={month} tasks={tasks} />;
                })}
        </div>
    );
}
